<template>
  <b-container fluid>
    <PunchCardListFilters />
    <template v-if="list_view === 'table'">
      <PunchCardDataTable />
    </template>
    <template v-else>
      <div class="list-view-wrapper mt-4">
        <div id="list-view-toggle-wrapper" class="text-right">
          <PunchCardListViewToggle />
        </div>
        <template v-if="loading || campaigns.length === 0">
          <div class="p-3 text-center empty-template">
            {{ loading ? "Loading..." : campaigns.length === 0 ? "No records found." : "" }}
          </div>
        </template>
        <template v-else>
          <PunchCardGalleryView v-if="list_view === 'gallery'" />
          <PunchCardDeckView v-if="list_view === 'deck'" />
        </template>
      </div>
    </template>
    <Pagination class="mt-3"
      :currentPage="pagination.currentPage"
      :totalRows="pagination.totalRows"
      :dataPerPage="pagination.dataPerPage"
      :maxPage="pagination.maxPage"
      @setDataPerPage="setDataPerPage"
      @goToPage="getCampaigns"
      cssClass="shadow-none border-0 bg-transparent"
      :hasPerPage="true"
      :hasNoVModel="true" />
  </b-container>
</template>

<script>
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import PunchCardListFilters from '@/components/punch-card/PunchCardListFilters.vue';
import PunchCardDataTable from '@/components/punch-card/PunchCardDataTable.vue';
import PunchCardGalleryView from '@/components/punch-card/PunchCardGalleryView.vue';
import PunchCardDeckView from '@/components/punch-card/PunchCardDeckView.vue';
import Pagination from "@/components/common/Pagination.vue";
import PunchCardListViewToggle from "@/components/punch-card/PunchCardListViewToggle.vue";

export default {
  components: {
    PunchCardListFilters,
    PunchCardDataTable,
    PunchCardGalleryView,
    PunchCardDeckView,
    Pagination,
    PunchCardListViewToggle
  },
  computed: {
    ...mapState("punchCard", ["loading", "listFilters"]),
    ...mapFields("punchCard", ["pagination", "list_view", "campaigns"])
  },
  mounted() {
    this.$root.$on("doSeachPunchCardCampaign", () => this.getCampaigns());
  },
  beforeDestroy() {
    this.$root.$off("doSeachPunchCardCampaign");
    this.list_view = "table";
    this.campaigns = [];
  },
  created() {
    this.getCampaigns();
  },
  methods: {
    getCampaigns(page = 1) {
      this.$store.dispatch("punchCard/getCampaigns", {
        page: page,
        filters: {
          status: this.listFilters.status,
          name: this.listFilters.keyword
        },
        per_page: this.pagination.dataPerPage,
        sort: this.listFilters.sort
      });
    },
    setDataPerPage(value) {
      this.pagination.dataPerPage = value;

      this.getCampaigns();
    }
  }
}
</script>

<style lang="scss" scoped>
.container-fluid {
  max-width: 95%;
}

.list-view-wrapper {
  max-height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
}

#list-view-toggle-wrapper {
  border-radius: 7px;
  background-color: #ECEEEE;
  padding: 5px 15px;
  height: 36.5px;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 9;
}

.empty-template {
  font-size: 14px;
  margin-top: calc(1.15rem + 1px);
}
</style>
